import i18nEnum from '@/i18ns/vi/i18nEnum';

export default [
  {
    path: '/allocation-decision/:key?',
    name: 'allocationDecision',
    component: () =>
      import(
        /* webpackChunkName:'demo'*/ '@/views/allocation/AllocationDecisionList.vue'
      ),
    meta: {
      orgPackCodeType: [i18nEnum.OrganizationPackCodeType.STC, i18nEnum.OrganizationPackCodeType.PTC],
    },
  },
  {
    path: '/allocation-decision-ptc/:key?',
    name: 'allocationDecisionPTC',
    component: () =>
      import(
        /* webpackChunkName:'demo'*/ '@/views/allocation/AllocationDecisionList.vue'
      ),
    meta: {
      orgPackCodeType: [i18nEnum.OrganizationPackCodeType.PTC],
    },
  },
  {
    path: '/allocation-decision-dvcq/:key?',
    name: 'allocationDecisionDVCQ',
    component: () =>
      import(
        /* webpackChunkName:'demo'*/ '@/views/allocation/AllocationDecisionDVCQList.vue'
      ),
    meta: {
      orgPackCodeType: [i18nEnum.OrganizationPackCodeType.DVCQSN],
    },
  },
  {
    path: '/allocation-receive-scq/:key?',
    name: 'allocationReceiveSCQ',
    component: () =>
      import(
        /* webpackChunkName:'demo'*/ '@/views/allocation/AllocationReceiveSCQList.vue'
      ),
    meta: {
      orgPackCodeType: [i18nEnum.OrganizationPackCodeType.DVCQSN],
    },
  },
  {
    path: '/allcation-tracking/:key?',
    name: 'allocationTrackingSTC',
    component: () =>
      import(
        /* webpackChunkName:'demo'*/ '@/views/allocation/AllocationTracking.vue'
      ),
    meta: {
      orgPackCodeType: [i18nEnum.OrganizationPackCodeType.STC],
    },
  },
  {
    path: '/allocation-tracking-ptc/:key?',
    name: 'allocationTrackingPTC',
    component: () =>
      import(
        /* webpackChunkName:'demo'*/ '@/views/allocation/AllocationTracking.vue'
      ),
    meta: {
      orgPackCodeType: [i18nEnum.OrganizationPackCodeType.PTC],
    },
  },
  {
    path: '/allocation-receive-hcsn/:key?',
    name: 'AllocationReceiveHCSNC3',
    component: () =>
      import(
        /* webpackChunkName:'demo'*/ '@/views/allocation/AllocationReceiveHCSNList.vue'
      ),
    meta: {
      orgPackCodeType: [i18nEnum.OrganizationPackCodeType.HCSN],
      ParentOrgPackCodeType: [i18nEnum.OrganizationPackCodeType.DVCQSN, i18nEnum.OrganizationPackCodeType.PTC],
    },
  },
  {
    path: '/allocation-receive-hcsn-under-stc/:key?',
    name: 'AllocationReceiveHCSNUnderSTC',
    component: () =>
      import(
        /* webpackChunkName:'demo'*/ '@/views/allocation/AllocationReceiveHCSNUnderStcList.vue'
      ),
    meta: {
      orgPackCodeType: [i18nEnum.OrganizationPackCodeType.HCSN],
      ParentOrgPackCodeType: [i18nEnum.OrganizationPackCodeType.STC],
    },
  },
  {
    path: '/allocation-implement/:key?',
    name: 'allocationImplement',
    component: () =>
      import(
        /* webpackChunkName:'demo'*/ '@/views/allocationImplement/AllocationImplementList.vue'
      ),
    meta: {
      orgPackCodeType: [i18nEnum.OrganizationPackCodeType.STC],
    },
  },
  {
    path: '/allocation-implement-ptc/:key?',
    name: 'allocationImplementPTC',
    component: () =>
      import(
        /* webpackChunkName:'demo'*/ '@/views/allocationImplement/AllocationImplementList.vue'
      ),
    meta: {
      orgPackCodeType: [i18nEnum.OrganizationPackCodeType.PTC],
    },
  },
  {
    path: '/allocation-implement-dvcq/:key?',
    name: 'allocationImplementDVCQ',
    component: () =>
      import(
        /* webpackChunkName:'demo'*/ '@/views/allocationImplement/AllocationImplementList.vue'
      ),
    meta: {
      orgPackCodeType: [i18nEnum.OrganizationPackCodeType.DVCQSN],
    },
  },
  {
    path: '/allocation-implement-scq/:key?',
    name: 'allocationImplementSCQ',
    component: () =>
      import(
        /* webpackChunkName:'demo'*/ '@/views/allocationImplement/AllocationImplementList.vue'
      ),
    meta: {
      orgPackCodeType: [i18nEnum.OrganizationPackCodeType.DVCQSN],
    },
  },
  {
    path: '/allocation-deliver/:key?',
    name: 'allocationDeliver',
    component: () =>
      import(
        /* webpackChunkName:'demo'*/ '@/views/allocationDeliver/AllocationDeliverList.vue'
      ),
    meta: {
      orgPackCodeType: [i18nEnum.OrganizationPackCodeType.STC],
    },
  },
  {
    path: '/allocation-deliver-ptc/:key?',
    name: 'allocationDeliverPTC',
    component: () =>
      import(
        /* webpackChunkName:'demo'*/ '@/views/allocationDeliver/AllocationDeliverPtcList.vue'
      ),
    meta: {
      orgPackCodeType: [i18nEnum.OrganizationPackCodeType.PTC],
    },
  },
  {
    path: '/allocation-deliver-dvcq', //Tạm thời show tính năng đang phát triển
    name: 'allocationDeliverPCQ',
    component: () => import(/* webpackChunkName:'demo'*/ '@/views/demo/Publishing.vue'),
    meta: {
      anonymous: true,
    },
  },
  {
    path: '/allocation-deliver-scq', //Tạm thời show tính năng đang phát triển
    name: 'allocationDeliverDVCQ',
    component: () => import(
      /* webpackChunkName:'demo'*/ '@/views/allocationDeliver/AllocationDeliverSCQList.vue'
    ),
    meta: {
      anonymous: true,
    },
  },
];
